let inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];

class FooterCoreService {
    constructor($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
        this.$q = $q;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
        this.$http = $http;
        this.ngAuthSettings = ngAuthSettings;
    }

    sendMailNewsletter(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.mailNewsletter,
                data: this.$httpParamSerializerJQLike(data),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch((reason) => {
                reject(reason);
            });
        });
    }
}

FooterCoreService.$inject = inject;

export default FooterCoreService;



// WEBPACK FOOTER //
// ./www/components/footer-core/footer-core.service.js